import React from "react"
import CustomTable from "../../components/CustomTable";
import { addQualificationName, editQualificationName, getAllQualifications, qualificationsUpdateApprovedAndUnapproved } from "../../services/ApiServices";
import { ApprovedAndUnApprovedBtn } from "../../components/ApprovedAndUnApprovedBtn";
import { EditButton } from "../../components/masterDataForm/EditButton";
import { AddButton } from "../../components/masterDataForm/AddButton";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import AddMasterDataWithCountryCode from "../../components/masterDataForm/AddMasterDataWithCountryCode";
import EditMasterFormWithCountryCode from "../../components/masterDataForm/EditMasterFormWithCountryCode";
const Qualifications = () => {

    const dispatch = useDispatch();
    const qualificationsInfo = useSelector(state => state?.getAllQualifications?.qualification);

    const [showAddQualifications, setAddQualificationsShow] = React.useState(false);
    const [showQualifications, setQualificationsShow] = React.useState(false);
    const [qualificationsValName, setQualificationsValName] = React.useState();

    React.useEffect(() => {
        const fetchUsers = async () => {
            try {
                const res = await getAllQualifications();
                dispatch({ type: 'GET_ALL_QUALIFICATIONS', payload: res.data.data })
            } catch (error) {
                console.error("Error fetching users:", error);
            }
        };

        fetchUsers();
    }, [dispatch]);

    const addQualificationsHandle = async (qualificationsName) => {
        try {
            const addQualificationNames = await addQualificationName(qualificationsName);
            if(addQualificationNames.status === 200) {
                dispatch({ type: 'ADD_QUALIFICATION_NAME', payload: addQualificationNames.data?.data})
                toast.success(addQualificationNames.data?.message)
            }
        } catch (error) {
            toast.error(error.response?.data?.message)
        }
    };

    const editQualificationsHandle = async (qualifications) => {
        try {
            const qualificationsPayload = {
                qualificationId: qualifications?.statusId,
                name: qualifications?.name,
                isoCode: qualifications?.isoCode
            }
            const editQualificationsNames = await editQualificationName(qualificationsPayload);
            if(editQualificationsNames.status === 200) {
                dispatch({ type: 'UPDATE_QUALIFICATION_NAME', payload: editQualificationsNames.data?.data})
                toast.success(editQualificationsNames.data?.message)
            }
        } catch (error) {
            toast.error(error.response?.data?.message)
        }
    };

    const qualificationApprovedAndUnAprooved = async (qualificationId) => {
        try {
            const approvedAndUnapprovedStatus = await qualificationsUpdateApprovedAndUnapproved(qualificationId);
            if(approvedAndUnapprovedStatus.status === 200) {
                dispatch({ type: 'UPDATE_QUALIFICATION_STATUS', payload: approvedAndUnapprovedStatus.data?.data})
                toast.success(approvedAndUnapprovedStatus.data?.message)
            }
        } catch (error) {
            toast.error(error.response?.data?.message)
        }
    };

    const colDefs = [
            { field: "name", flex: 2, headerName: 'Name' },
            { field: "isApproved", flex: 2, headerName: 'Status', cellRenderer: (val) => {
            return ( <ApprovedAndUnApprovedBtn status={val?.data?.isApproved}  statusId={val.data._id} handleApprovedAndUnAprooved={qualificationApprovedAndUnAprooved}/> )
            }
        },
            { field: '_id', flex: 2, headerName: 'Action', cellRenderer: (val) => ( <EditButton name={val.data.name} statusId={val.data._id} isoCode={val.data?.isoCode} hadnleEditName={setQualificationsValName} handleEditBtn={setQualificationsShow} />) }
        ];

    return(
        <React.Fragment>
            <div className="aside-heading">
                <h3>Qualifications</h3>
            </div>
            <AddButton formName="Qualifications" handleAddBtn={setAddQualificationsShow} />
            <CustomTable colDefs={colDefs} rowData={qualificationsInfo} />
            <AddMasterDataWithCountryCode formName="Qualifications" addMasterData={addQualificationsHandle} showAddForm={showAddQualifications} setShowAddForm={setAddQualificationsShow} />
            <EditMasterFormWithCountryCode formName="Qualifications" editMasterDataName={qualificationsValName} editMasterData={editQualificationsHandle} showEditForm={showQualifications} setShowEditForm={setQualificationsShow}/>
        </React.Fragment>
    )
};
export default Qualifications;